import config from "../config.json";
import { apiClient, getAccessToken, getUserEmail } from "./apiClient";

// ── Building ─────────────────────────────────────────────────
const SearchBuilding = async (params) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/buildings/search`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.get(url, { headers, params, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const GetBuildingById = async (id) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/buildings/${id}`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const CreateBuilding = async (req) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/buildings`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.post(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const UpdateBuilding = async (id, req) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/buildings/${id}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.put(url, JSON.stringify(req), { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const DeleteBuilding = async (id) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/buildings/${id}`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.delete(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

// ── Province ─────────────────────────────────────────────────
const SearchProvince = async (params) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/provinces/search`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.get(url, { headers, params, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const GetProvinceById = async (id) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/provinces/${id}`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

// ── District ─────────────────────────────────────────────────
const SearchDistrict = async (params) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/districts/search`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.get(url, { headers, params, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

const GetDistrictById = async (id) => {
  const token = await getAccessToken();
  const url = `${config.API_URL}/districts/${id}`;
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
    User: getUserEmail(),
  };
  try {
    return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
  } catch (error) {
    throw error;
  }
};

// ─────────────────────────────────────────────────────────────
const LocationService = {
  SearchBuilding,
  GetBuildingById,
  CreateBuilding,
  UpdateBuilding,
  DeleteBuilding,
  SearchProvince,
  GetProvinceById,
  SearchDistrict,
  GetDistrictById,
};

export default LocationService;